export default "__VITE_ASSET__Cqmu19BA__"